import { DeleteOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import React from 'react';
import { Props } from '.';
import Icon from '../../../../components/icon/Icon';
import { EventVm, MatchCoachVm } from '../../../../utils/api';

class CoachExclusion extends React.PureComponent<Props> {
    public render = (): React.ReactElement => {
        const { event, coaches, clearEvent, deleteEvent } = this.props;
        const eventVm = event as EventVm;
        const eventExists = !!eventVm.id;

        const matchCoach = coaches.find(
            (c: MatchCoachVm): boolean => c.id === event?.exclusion?.excludedCoachId
        );

        return (
            <div className="event-create">
                <div className="c-shot-form__caps-label">Coach</div>
                <div className="content" style={{ color: '#fff', marginBottom: 8 }}>
                    {matchCoach ? `${matchCoach.coach.name} ${matchCoach.coach.surname}` : ''}
                </div>
                <div className="c-shot-form__caps-label">Suspension type</div>
                <div className="c-shot-form__grid">
                    <span className="c-shot-pill c-shot-pill--active" role="button">
                        Penalty
                    </span>
                    <div className="c-shot-form__actions">
                        <span
                            className="c-shot-form__action-btn"
                            onClick={(): void => clearEvent()}
                            role="button"
                            title="Close"
                        >
                            <Icon name="icon-times" />
                        </span>
                        {eventExists && (
                            <Popconfirm
                                title="Are you sure you want to delete this event?"
                                onConfirm={(): void => deleteEvent(eventVm)}
                                okText="Delete"
                                okButtonProps={{ danger: true }}
                                cancelText="Cancel"
                            >
                                <span
                                    className="c-shot-form__action-btn c-shot-form__action-btn--delete"
                                    role="button"
                                    title="Delete"
                                >
                                    <DeleteOutlined />
                                </span>
                            </Popconfirm>
                        )}
                    </div>
                </div>
            </div>
        );
    };
}

export default CoachExclusion;
